import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FlowChartDataService} from '../../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-response-quentionare-dialog',
  templateUrl: './response-quentionare-dialog.component.html',
  styleUrls: ['./response-quentionare-dialog.component.scss']
})
export class ResponseQuentionareDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  section: any;
  constructor(public flowChartDataService: FlowChartDataService) { }

  ngOnInit() {
  }



  onOkClicked(): boolean {
    return false;
  }

}

